import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./sidebar.module.scss"
import Tag from "../../atoms/tag"
import Wrapper from "../../atoms/wrapper"
import SidebarItem from "../../molecules/sidebar-item"

const Sidebar = ({ color, sidebar, title, secondaryTitle, customTitle }) => {
  const { site, allSanityDictionary, allSanityCountry } = useStaticQuery(
    graphql`
      {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allSanityCountry {
          nodes {
            url
            abbreviation
          }
        }
        allSanityDictionary {
          nodes {
            key {
              current
            }
            value
          }
        }
      }
    `
  )

  const country = allSanityCountry.nodes.find(
    (c) => c.url === site.siteMetadata.siteUrl
  ).abbreviation

  const regionSidebar = sidebar.filter(
    (c) => c.country?.abbreviation === country || !c.country
  )

  if (regionSidebar.length > 0) {
    return (
      <>
        <Wrapper className={styles.title}>
          <Tag color="black">
            {customTitle
              ? title
              : allSanityDictionary.nodes.find(
                  (item) => item.key.current === title
                )?.value}
          </Tag>
          {secondaryTitle ? (
            <Tag color={color || "paper"}>{secondaryTitle}</Tag>
          ) : (
            ""
          )}
        </Wrapper>
        <div className={styles.sidebar}>
          {regionSidebar.map((item) => (
            <SidebarItem key={item.id} item={item} sidebarContainer />
          ))}
        </div>
      </>
    )
  }
  return ""
}

export default Sidebar

Sidebar.propTypes = {
  color: PropTypes.string,
  sidebar: PropTypes.array,
  title: PropTypes.string,
  secondaryTitle: PropTypes.string,
  customTitle: PropTypes.bool,
}

Sidebar.defaultProps = {
  color: "paper",
  sidebar: [],
  title: "",
  secondaryTitle: "",
  customTitle: false,
}
